import { Component } from '@angular/core';

@Component({
  selector: 'app-task-center',
  templateUrl: './task-center.component.html',
  styleUrls: ['./task-center.component.css']
})
export class TaskCenterComponent {

  imageUrls: string[] = [];


  ngOnInit() {
    // Simulating backend API response
    this.fetchImages();

  }

  fetchImages() {
    // Replace with actual API call if needed
    this.imageUrls = [
      "https://inytesconnedwipdvfs.koinpark.com/ipfs/QmTtCpzm1pnqUD21whNZuJVmWywdeKmcqEGu47ryYHjkk5",
      "https://inytesconnedwipdvfs.koinpark.com/ipfs/Qmd2qoxs9fcE57bsQ8b5HP4gQ8JRyZHhPY67j7Uido94xh",
      "https://inytesconnedwipdvfs.koinpark.com/ipfs/QmXtxEBVzPEjWQ6PyYA4bQtfzLUv1gNEZzNS1wEn3toZ64",
    ];
  }

}
